var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 48,
    viewBox: "0 0 47 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.09375,
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "#79B52D",
    fillOpacity: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3.09375,
    width: 41,
    height: 41,
    rx: 20.5,
    fill: "#79B52D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5469 29.1499L22.2594 31.2499C22.6094 31.5999 23.3969 31.7749 23.9219 31.7749H27.2469C28.2969 31.7749 29.4344 30.9874 29.6969 29.9374L31.7969 23.5499C32.2344 22.3249 31.4469 21.2749 30.1344 21.2749H26.6344C26.1094 21.2749 25.6719 20.8374 25.7594 20.2249L26.1969 17.4249C26.3719 16.6374 25.8469 15.7624 25.0594 15.4999C24.3594 15.2374 23.4844 15.5874 23.1344 16.1124L19.5469 21.4499",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.082 29.1501V20.5751C15.082 19.3501 15.607 18.9126 16.832 18.9126H17.707C18.932 18.9126 19.457 19.3501 19.457 20.5751V29.1501C19.457 30.3751 18.932 30.8126 17.707 30.8126H16.832C15.607 30.8126 15.082 30.3751 15.082 29.1501Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadSuccess);
export default __webpack_public_path__ + "static/media/download-success.849f3c8b761bdbdee472819ba9a064dd.svg";
export { ForwardRef as ReactComponent };